import React, { MouseEvent, useCallback } from 'react';
import { SoundWave } from '@bpm-web-app/create-api-sdk';

import styles from './create-wave.module.css';

interface CreateWaveProps {
    wave: SoundWave;
    handleSeek: (to: number) => void;
    elapsed: number;
    duration: string;
    isPaused: boolean;
}

export function CreateWave({ wave, handleSeek, elapsed, duration, isPaused }: CreateWaveProps) {
    const safeDuration = +duration;
    const elapsedPercentage = safeDuration > 0 ? Math.min((elapsed / safeDuration) * 100, 100) : 0;

    const onClick = useCallback(
        (e: MouseEvent) => {
            if (safeDuration <= 0) return;
            const { width, left } = e.currentTarget.getBoundingClientRect();
            const offset = e.clientX - left;
            let percentage = (offset / width) * 100;
            if (percentage < 0) percentage = 0;
            if (percentage > 100) percentage = 100;
            handleSeek((safeDuration / 100) * percentage);
        },
        [safeDuration, handleSeek]
    );

    if (!wave?.gray || !wave?.green || !wave?.light) return null;

    return (
        <div
            role="progressbar"
            aria-valuenow={elapsedPercentage || 0}
            tabIndex={0}
            aria-valuemin={0}
            aria-live="assertive"
            aria-valuemax={100}
            className={styles['create-wave']}
            onClick={onClick}
            onKeyDown={() => { }}
        >
            <div
                className={styles['create-wave__wave']}
                style={{
                    WebkitMaskImage: `url(${wave.gray})`,
                    maskImage: `url(${wave.gray})`,
                }}
            />
            {elapsed > 0 && (
                <div className={styles['create-wave__elapsed-wrapper']} style={{ width: `${elapsedPercentage}%` }}>
                    <div
                        className={styles['create-wave__wave--elapsed']}
                        style={{
                            width: `calc(100% / ${elapsedPercentage / 100})`,
                            ...(!isPaused
                                ? {
                                    backgroundColor: 'var(--color-main-dynamic)',
                                    WebkitMaskImage: `url(${wave.gray})`,
                                    maskImage: `url(${wave.gray})`,
                                }
                                : {
                                    backgroundImage: `url(${wave.light})`,
                                }),
                        }}
                    />
                </div>
            )}
        </div>
    );
}
